import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ticker-value',
  templateUrl: './ticker-value.component.html',
  styleUrls: ['./ticker-value.component.scss']
})
export class TickerValueComponent implements OnInit {
  @Input() value: string | number;
  @Input() showLabel: boolean;
  @Input() category: string;
  @Input() tooltipDesc: string;
  @Input() tooltipPlacement: string = 'bottom';
  public class;
  public icon;
  constructor() { }

  ngOnInit(): void {
    if(this.value){
      if(typeof(this.value) == 'string') {
        if(this.value == 'positive' || this.value == 'improving' || this.value == 'low' || this.value == 'favorable' || this.value.toLowerCase() == 'bullish'){
          this.class = 'badge-light-success';
          if(this.category == 'social-sentiment'){
            this.icon = 'plus-square';
          }
          if(this.category == 'fundamental'){
            this.icon = 'arrow-up-right';
          }
        } else if (this.value == 'weakening' || this.value == 'negative' || this.value.toLowerCase() == 'unfavorable' || this.value.toLowerCase() == 'bearish'){
          this.class = 'badge-light-danger';
          if(this.category == 'social-sentiment'){
            this.icon = 'minus-square';
          }
          if(this.category == 'fundamental'){
            this.icon = 'arrow-down-right';
          }
        } else if(this.value == 'medium' || this.value.toLowerCase() == 'neutral' || this.value == 'high'){
          this.class = 'badge-light-warning';
        }
      } else {
        if(this.value > 70){
          this.class = 'badge-light-success';
          this.icon = 'thumbs-up';
          this.tooltipDesc = 'Open or Overweight';
        } else if (this.value >= 40 && this.value <= 70){
          this.class = 'badge-light-warning';
          this.icon = 'shield';
          this.tooltipDesc = 'Watch or Hold';
        } else {
          this.class = 'badge-light-danger';
          this.icon = 'thumbs-down';
          this.tooltipDesc = 'Close or Reduce';
        }
        this.value = this.value.toString();
      }
    }
  }

}
